import { useContext } from "react";

import { BoardSendToContext } from "./BoardSendToContext";

export const useBoardSendTo = () => useContext(BoardSendToContext);
